<template>
  <v-dialog :value="shown" persistent max-width="420" @input="() => {}">
    <v-card>
      <v-card-title class="text-h6">Авторизация</v-card-title>

      <v-card-subtitle v-if="wasAuthenticated">
        Сессия истекла. Войдите снова — страница и введённые данные сохранятся.
      </v-card-subtitle>

      <v-divider />

      <v-card-text class="pt-4">
        <template v-if="!needConfirmation">
          <v-text-field
            v-model="username"
            label="Логин или email"
            outlined
            dense
            autofocus
            :disabled="loading"
            @keyup.enter="sendCredentials"
          />

          <v-text-field
            v-model="password"
            label="Пароль"
            type="password"
            outlined
            dense
            hide-details
            :disabled="loading"
            @keyup.enter="sendCredentials"
          />
        </template>

        <v-text-field
          v-else
          v-model="code"
          label="Код подтверждения"
          outlined
          dense
          autofocus
          hide-details
          :disabled="loading"
          @keyup.enter="sendConfirm"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions class="flex-column align-stretch pa-4">
        <v-btn
          color="primary"
          block
          :loading="loading"
          @click="needConfirmation ? sendConfirm() : sendCredentials()"
        >
          {{ needConfirmation ? 'Отправить' : 'Войти' }}
        </v-btn>

        <v-btn
          v-if="needConfirmation"
          text
          small
          class="mt-2"
          :disabled="loading"
          @click="backToCredentials"
        >
          Ввести другой логин
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoginDialog',

  data() {
    return {
      username: null,
      password: null,
      code: null,
    }
  },

  computed: {
    ...mapGetters({
      isAuth: 'auth/isAuth',
      loading: 'auth/loading',
      wasDefined: 'auth/wasDefined',
      wasAuthenticated: 'auth/wasAuthenticated',
      needConfirmation: 'auth/needConfirmation',
    }),

    shown() {
      return this.wasDefined && !this.isAuth
    },
  },

  methods: {
    ...mapActions({
      login: 'auth/login',
      verify: 'auth/verify',
      setError: 'shared/setError',
    }),

    sendCredentials() {
      if (this.loading) return

      this.login({
        login: this.username,
        password: this.password,
      }).catch(this.notifyError)
    },

    sendConfirm() {
      if (this.loading) return

      this.verify({
        login: this.username,
        code: this.code,
      }).catch(this.notifyError)
    },

    backToCredentials() {
      this.code = null
      this.password = null
      this.$store.commit('auth/SET_NEED_CONFIRMATION', false)
    },

    notifyError(error) {
      if (error?.response?.status === 403) return

      const body = error?.response?.data

      this.setError({
        errors: null,
        message: body?.message || body?.data?.message || 'Не удалось авторизоваться',
        status: 'error',
      })
    },
  },
}
</script>
